import { ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { InitService } from './services/init/init.service';
import { Company } from './_models/company.model';
import { Observable } from 'rxjs';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { authInterceptor } from './_interceptors/auth.interceptor';
import { errorHandlingInterceptor } from './_interceptors/error-handling.interceptor';
import { EmpresaInit } from './_models/empresa.model';
import { providePrimeNG } from 'primeng/config';
import { RegistroPreset } from '../styles/primeng-preset';
import { AutoFocus } from 'primeng/autofocus';

// ponytail: PrimeNG 20-21 bug. p-select binds [pAutoFocus]="undefined", which AutoFocus treats as "on" and
// sets the native autofocus attribute, so the browser focuses and scrolls to the first select on load
// (e.g. the paginator). Same semantics as the PrimeNG 22 fix (undefined → false). Remove when PrimeNG >= 22.
const autoFocusContentChecked = AutoFocus.prototype.onAfterContentChecked;
AutoFocus.prototype.onAfterContentChecked = function (this: AutoFocus) {
  this.autofocus ??= false;
  autoFocusContentChecked.call(this);
};

export function initializeApp(initService: InitService): () => Observable<EmpresaInit> {
  return () => initService.getExternalReferences();
}


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, errorHandlingInterceptor]),),
    InitService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [InitService],
      multi: true
    }, provideAnimationsAsync('noop'),
    providePrimeNG({
      theme: {
        preset: RegistroPreset,
        options: { darkModeSelector: false, cssLayer: { name: 'primeng', order: 'tailwind-base, primeng, tailwind-utilities' } },
      },
      translation: {
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        firstDayOfWeek: 1, dateFormat: 'dd-mm-yy', today: 'Hoy', clear: 'Limpiar', weekHeader: 'Sem',
        chooseYear: 'Elegir año', chooseMonth: 'Elegir mes', chooseDate: 'Elegir fecha',
        prevYear: 'Año anterior', nextYear: 'Año siguiente', prevMonth: 'Mes anterior', nextMonth: 'Mes siguiente',
        prevDecade: 'Década anterior', nextDecade: 'Década siguiente',
        emptyMessage: 'Sin opciones', emptyFilterMessage: 'Sin resultados', emptySearchMessage: 'Sin resultados',
      },
    }),
  ]
};
